module.exports = __webpack_public_path__ + "static/media/Architecture_32.70cf5389.jpg";